import "./CSS/Footer.css";
import ellenylogo from "../assets/EllenyLogo.png"
import Facebook from "../assets/facebook-logo.png"
import Instagram from "../assets/instagram-logo.png"
import { useTranslation } from 'react-i18next';

function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <img className="footer-logo" src={ellenylogo} alt="Elleny Foundation Logo" />
            <p className="footer-tagline">{t("CopyrightParagraph")}</p>
          </div>

          <nav className="footer-nav">
            <h3 className="footer-nav-title">{t("QuickLinks")}</h3>
            <div className="footer-links-grid">
              <a href="/mission" className="footer-link">
                <span className="link-icon">→</span>
                {t("Mission")}
              </a>
              <a href="/impact" className="footer-link">
                <span className="link-icon">→</span>
                {t("Impact")}
              </a>
              <a href="/gallery" className="footer-link">
                <span className="link-icon">→</span>
                {t("Gallery")}
              </a>
              <a href="/about" className="footer-link">
                <span className="link-icon">→</span>
                {t("About")}
              </a>
              <a href="/contact" className="footer-link">
                <span className="link-icon">→</span>
                {t("Contact")}
              </a>
            </div>
          </nav>

          <div className="footer-connect">
            <a
              href="https://www.paypal.com/donate/?hosted_button_id=AY8U45QM5K5GJ"
              className="donate-footer modern-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("Donate")}
            </a>
            <h3 className="footer-connect-title">{t("Connect")}</h3>
            <div className="social-links">
              <a
                href="https://www.facebook.com/EllenyFound"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <img src={Facebook} alt='Facebook' className="social-icon"/>
              </a>
              <a
                href="https://www.instagram.com/ellenyfoundation/"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <img src={Instagram} alt='Instagram' className="social-icon" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} Elleny Foundation. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
